import { render, staticRenderFns } from "./list-brand.vue?vue&type=template&id=2e68ada2&scoped=true"
import script from "./list-brand.vue?vue&type=script&lang=js"
export * from "./list-brand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e68ada2",
  null
  
)

export default component.exports